import { LockOutlined } from "@ant-design/icons"
import { Button, Card, Flex, Result, Tag, Typography } from "antd"
import React from "react"

import { RoutesPaths } from "../../../../constants/routes.ts"
import { leadStatusColorMap } from "../../constants/lead-statuses.ts"
import { type Lead } from "../../types/lead.types.ts"

const { Title, Text } = Typography

interface LeadNotEditableProps {
  lead: Lead
}

export function LeadNotEditable({ lead }: LeadNotEditableProps) {
  const status = lead?.status_name
  const statusStyle = leadStatusColorMap?.[lead?.status]

  return (
    <Card size="small">
      <Result
        icon={null}
        title={
          <Flex justify={"center"} align={"center"} gap={"middle"}>
            <Title className={"m-0"} level={3}>
              Lead Status:
            </Title>
            <Tag style={statusStyle} className={"mt-1"}>
              {status}
            </Tag>
          </Flex>
        }
        subTitle="This lead is no longer available for editing."
        extra={
          <Flex vertical align={"center"} gap={"middle"}>
            <Text type={"secondary"}>
              <LockOutlined /> Read-only mode
            </Text>
            <Button type={"primary"} href={RoutesPaths.lead.view(lead?.id)}>
              View Lead
            </Button>
          </Flex>
        }
      />
    </Card>
  )
}
